import { Component, Inject, OnInit } from '@angular/core';
import { Blog } from './blog';
import { Router } from '@angular/router';
import { ApiRequestService } from '../../shared/api-request-service';
import { MAT_ICON, TOAST_STATE, ToastmessageService } from '../../toastmessage/toastmessage.service';
import { TranslationService } from '../../translation/translation.service';
import { HttpError } from '../../shared/httperror';
import { HttpErrorResponse } from '@angular/common/http';
import { GetBlogsResponse } from './getblogsresponse';
import { catchError, throwError } from 'rxjs';
import { BlogWithActive } from './blogwithactive';
import { UpdateBlogsPublishedTimestampRequest } from './updateblogspublishedtimestamprequest';
import { UpdateBlogsPublishedTimestampResponse } from './updateblogspublishedtimestampresponse';
import { DeleteBlogPopupComponent } from './delete-blog-popup/delete-blog-popup.component';
import { MatdialogService } from '../../matdialog/matdialog.service';
import { MetaService } from '../../meta/meta.service';

@Component({
    selector: 'app-blog',
    templateUrl: './blog.component.html',
    styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {

    blogList: Blog[] = [];

    filteredBlogs: BlogWithActive[] = [];

    blogsWithActiveArray: BlogWithActive[] = [];

    private _listFilter = '';

    get listFilter(): string {
        return this._listFilter;
    }
    set listFilter(value: string) {
        this._listFilter = value;
        this.filteredBlogs = this.performFilter(value);
    }

    getBlogsUrl = '/admin/get-blogs';

    configuratorBaseUrl = '';

    updateBlogPublishedTimestampUrl = '/admin/update-blog-timestamp';

    constructor(
        private _router: Router,
        private _toastMessageService: ToastmessageService,
        private _apiRequestService: ApiRequestService,
        @Inject('CONFIGURATOR_BASE_URL') private _configuratorBaseUrl: string,
        private _translateService: TranslationService,
        private _matDialogService: MatdialogService,
        private _metaService: MetaService
    ) {

        this.configuratorBaseUrl = _configuratorBaseUrl;

        this._metaService.settingUpOgUrl();
    }

    ngOnInit(): void {
        this.getBlogs();
    }

    getBlogs() {
        this._apiRequestService
            .sendRequest<{}, GetBlogsResponse>(this.configuratorBaseUrl, true, {}, true, this.getBlogsUrl)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const httpError: HttpError = error.error as HttpError;

                        this._toastMessageService.displayToastMessage(TOAST_STATE.error, 'HttpError hiba!', MAT_ICON.error);
                        this.dismissError();


                    });
                })
            )
            .subscribe((response: GetBlogsResponse) => {
                this.blogList = response.blogList as Blog[];

                let blogWithActiveArray: BlogWithActive[] = [];
                this.blogList.forEach((blog) => {
                    if (blog.publishedTimestamp !== null) {
                        const blogWithActive: BlogWithActive = {
                            blog: blog,
                            active: true
                        }
                        blogWithActiveArray.push(blogWithActive);
                    }
                    else {
                        const blogWithActive: BlogWithActive = {
                            blog: blog,
                            active: false
                        }
                        blogWithActiveArray.push(blogWithActive);
                    }
                })

                this.blogsWithActiveArray = [...blogWithActiveArray];
                this.filteredBlogs = this.blogsWithActiveArray;
            });
    }

    performFilter(filterBy: string): BlogWithActive[] {
        filterBy = filterBy.toLocaleLowerCase();
        return this.blogsWithActiveArray!.filter(
            (blogWithActive: BlogWithActive) =>
                blogWithActive.blog?.title?.toLocaleLowerCase().includes(filterBy)

        );
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }

    onChangeActive(blogWithActive: BlogWithActive) {
        this.blogsWithActiveArray?.forEach((blogWithActiveArrayElement => {
            if (blogWithActive.blog?.routerLink === blogWithActiveArrayElement.blog?.routerLink) {
                blogWithActiveArrayElement.active = !blogWithActiveArrayElement.active
            }
        }))
    }

    updateBlog() {
        const updateBlogsPublishedTimestampRequest: UpdateBlogsPublishedTimestampRequest = {
            blogWithActiveList: this.blogsWithActiveArray
        }

        this._apiRequestService
            .sendRequest<UpdateBlogsPublishedTimestampRequest, UpdateBlogsPublishedTimestampResponse>(this.configuratorBaseUrl, true, updateBlogsPublishedTimestampRequest, true, this.updateBlogPublishedTimestampUrl)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => {
                        const httpError: HttpError = error.error as HttpError;

                        this._toastMessageService.displayToastMessage(TOAST_STATE.error, 'HttpError hiba!', MAT_ICON.error);
                        this.dismissError();


                    });
                })
            )
            .subscribe((response: UpdateBlogsPublishedTimestampResponse) => {
                this._toastMessageService.displayToastMessage(TOAST_STATE.success, response.responseMessage!, MAT_ICON.success);
                this.dismissError();


            });
    }

    openDeleteBlogPopup(blog: Blog) {
        this._matDialogService.openPopupWithData(blog, DeleteBlogPopupComponent);
    }
}
